export default {
  name: "BottomInfo"
};